import daniel from "../assets/team/daniel.jpg";
import efe from "../assets/team/efe.jpg";
import bola from "../assets/team/bola.jpg";
import tayo from "../assets/team/tayo.jpg";

export const ourTeamInfo = [
  {
    image: daniel,
    name: "Daniel Obot",
    title: "Chief Executive Officer",
    social_medial_name: "Linkedin",
    social_media_link: "https://www.linkedin.com/in/danieljonesobot/",
    bio: ``,
  },
  {
    image: efe,
    name: "Efe Ohwonigho",
    title: "HChief Operations Officer",
    social_medial_name: "Linkedin",
    social_media_link: "https://www.linkedin.com/in/efe-ohwonigho-41a585a2/",
    bio: ``,
  },
  {
    image: bola,
    name: "Head, Customer Success and Compliance Support",
    title: "Platform Engineer",
    social_medial_name: "Linkedin",
    social_media_link:
      "https://www.linkedin.com/in/bola-lateef-odeshina-b084b9268/",
    bio: ``,
  },
  {
    image: tayo,
    name: "Adetayo Adetokun",
    title: "Engineering Manager",
    social_medial_name: "Linkedin",
    social_media_link:
      "https://www.linkedin.com/in/bola-lateef-odeshina-b084b9268/",
    bio: ``,
  },
];
